export { default } from "./AdminContentTable";
